module.exports = __webpack_public_path__ + "img/horizontal_3_6_8019.8e9c6d7d.png";